var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.174,
    height: 16.342,
    viewBox: "0 0 34.174 27.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8307",
    "data-name": "Group 8307",
    transform: "translate(16329 19309.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16046",
    "data-name": "Path 16046",
    d: "M.056,42.29l6.106,3.947c3.323,2.148,6.654,4.283,9.962,6.455a1.552,1.552,0,0,0,1.93,0q7.595-4.949,15.22-9.853c.246-.159.495-.314.837-.531.026.318.06.543.06.767q.005,7.93,0,15.859a4.188,4.188,0,0,1-4.393,4.407q-12.688.011-25.375,0A4.178,4.178,0,0,1,.015,59.178C-.012,53.7.006,48.226.008,42.75c0-.1.021-.207.048-.46",
    transform: "translate(-16329 -19345.238)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16047",
    "data-name": "Path 16047",
    d: "M17.388,25.746c4.253,0,8.505-.009,12.758,0a4.175,4.175,0,0,1,4.065,2.92.748.748,0,0,1-.357,1q-7.96,5.118-15.891,10.281a.961.961,0,0,1-1.23,0Q8.8,34.79.84,29.673a.749.749,0,0,1-.358-1A4.183,4.183,0,0,1,4.549,25.75c4.28-.013,8.559,0,12.839,0",
    transform: "translate(-16329.259 -19334.973)",
    fill: "#5aa2fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2999e037406aaff24697da46b682a91c.svg";
export { ForwardRef as ReactComponent };